module.exports = __webpack_public_path__ + "img/list1_bg3.647fbe51.png";